import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AuthService} from './services/auth.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {


    constructor(
        private authService: AuthService,
    ) {
    }

    ngOnInit() {
        let accessToken: string | null | undefined = window.location.href.split('accessToken=')[1]?.split('&')[0];
        if (!accessToken) {
            accessToken = sessionStorage.getItem('accessToken')
        }
        this.authService.setAccessJwt(accessToken)
    }
}
